import apiClient from './apiClient';

export interface User {
  id: string;
  user_type: 'nurse' | 'patient';
  created_at: string;
  updated_at: string;
  email: string;
  confirmed_at: string | null;
  current_sign_in_at: string | null;
  resigned_at: string | null;
  registration_status: 'provisional' | 'registered';
  nurse_id?: string | null;
  patient_id?: string | null;
}

export interface UserListParams {
  // 基本検索
  email?: string;
  // 登録期間
  created_at_start?: string;
  created_at_end?: string;
  // メール認証状態
  email_confirmed?: boolean;
  // ログイン履歴
  has_logged_in?: boolean;
  // ユーザータイプ
  user_type?: 'nurse' | 'patient';
  // 登録状況
  registration_status?: 'provisional' | 'registered' | 'all';
  // 退会状態
  resignation_status?: 'false' | 'true' | 'only';
  // ページネーション
  page?: number;
  page_size?: number;
  // ソート
  ordering?: string;
}

export interface UserListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: User[];
}

export const getUsers = async(params?: UserListParams): Promise<UserListResponse> => {
  const response = await apiClient.get<UserListResponse>('/external/users/', { params });
  return response.data;
};
export const getUser = async(id: string): Promise<User> => {
  const response = await apiClient.get<User>(`/external/users/${id}/`);
  return response.data;
};
export const deleteUser = async(id: string): Promise<void> => {
  await apiClient.delete(`/external/users/${id}/`);
};
